<template>
	<div class="news">
		<div class="news-list" v-show="!details">
			<ul>
				<li v-for="(item, index) in newsList" :key="index">
					<el-row>
						<el-col :span="3">
							<p>{{ item.date }}</p>
							<p>{{ item.year }}</p>
						</el-col>
						<el-col :span="21">
							<p @click="lookDetail(item)">{{ item.title }}</p>
							<p>{{ item.introduction }}</p>
						</el-col>
					</el-row>
				</li>
				<li>
					<el-pagination
						background
						prev-text="上一页"
						next-text="下一页"
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						layout="prev, pager, next"
						:page-size="5"
						:total="list.length"
					></el-pagination>
				</li>
			</ul>
		</div>
		<newsDetail v-show="details"></newsDetail>
	</div>
</template>

<script>
import axios from 'axios';
import '@/assets/css/news.less';
import newsDetail from './newsDetail.vue'
export default {
	name: 'index',
	data() {
		return {
			currentPage: 1,
			details:false,
			list: [
				{
					id: 1,
					date: '05/15',
					year: '2020',
					title: '区块链电子封条——安徽谯城法院，全省首例正式启用',
					introduction: '5月14日，亳州市谯城区人民法院首次启用区块链电子封条，查封了位于亳州市谯城区工业园区亳州亿都国际商城的不动产一处..'
				},
				{
					id: 2,
					date: '09/05',
					year: '2019',
					title: '两高一部国家课题成果——电子证据平台在吉林法院落地',
					introduction: '【成果巡礼】吉林中院：“与时间赛跑”，区块链技术在个人网络存证中如何应用？（转载最高人民法院智慧法院公众号）在互..'
				},
				{ id: 3, date: '05/15', year: '2017', title: '行政诉讼的期限', introduction: '行政诉讼是有期限的，根据不同类型的行政诉讼案件，法律规...' },
				{
					id: 4,
					date: '05/15',
					year: '2017',
					title: '人民调解和法院调解的区别',
					introduction:
						'人民调解 ，属于诉讼外调解的一种。是指在人民调解委员会主持下，以国家法律、法规、规章和社会公德规范为依据，对民间纠纷双方当事人进行调解、劝说，促使他们互相谅解、平等协商，自愿达成协议，消除纷争的活动。'
				}
			],
			newsList: []
		};
	},
	methods: {
		handleCurrentChange(val) {
			this.currentPage = val;
			this.newsList = this.list.slice((val - 1) * 5, val * 5);
		},
		lookDetail(item) {
			// window.open('#/newsDetail')
			localStorage.JIANDINGID = item.id;
			this.details = true
		}
	},
	components: {
		newsDetail
	},
	mounted() {

	},
	created() {
		this.details = false
		this.newsList = this.list.slice(0, 5);
	}
};
</script>

<style lang="less"></style>
